import type { Speaker, Language } from "@/shared/types"
import type { AsyncDataRequestStatus } from "nuxt/app"

interface ApiResponse {
  items: Speaker[]
  total: number
}

export const useSpeakerStore = () => {
  const speakers = useState<Speaker[]>("speaker.speakers", () => [])
  const status = useState<AsyncDataRequestStatus>("speaker.status", () => "idle")
  const error = useState<string>("speaker.error", () => "")

  async function fetchSpeakers(language?: Language) {
    status.value = "pending"
    error.value = ""

    return useAPI<ApiResponse>(
      "/speakers" + (language ? "?language=" + language : ""),
      {
        method: "GET",
        onResponse: ({ response }) => {
          if (response._data) {
            speakers.value = response._data.items ?? []
          }
          status.value = "success"
          error.value = ""
        },
      },
    )
  }

  return reactive({ speakers, status, error, fetchSpeakers })
}
